export const ISDEV = false;
export const SESSION_INIT_URL = getSessionInitUrl();
export const ENERGYMNTR_URL = getEnergymntrUrl();
export const SES_API = getSesApiUrl();
export const CHECK_CODE_API = getCheckcodeApiUrl();
export const GET_LANG_API = getGetlangApiUrl();
export const MAX_STEPS = 4;
export const MAX_CRUISE_SCREEN_TITLE_NUM = 32;
export const MIN_CRUISE_SECONDS_NUM = 10;
export const MAX_CRUISE_SECONDS_NUM = 3600;
export const CRUISE_PER_PAGE = 10;
export const CRUISE_SETTING_URL = getCruseSettingApiUrl();
export const CRUISE_API_KEY = getCruseSettingApiKey();
export const PR_CONTENT_URL = getPrContentsUrl();
export const GET_MWID_AUTHZDB = getAuthzdbUrl();
export const AUTHZDB_BASEURL = getAuthzdbUrl();
export const GRAND_ARCH_URL = getGrandArchUrl();
export const PPMS_URL = getPpmsUrl();
export const TERM_VER = 4;
export const MIERUKA_MANUAL = 'https://www.lapsys.co.jp/common/download/MierukaWeb_Manual.pdf';
export const ASSET_LIST = [
  {
    id: "solar_standard_s",
    name: "Standard solar power generation (All electricity sales)",
  },
  {
    id: "solar_standard_surplus_electricity_sales",
    name: "Standard solar power generation (Surplus electricity sales)",
  },
  {
    id: "solar_standard_selfconsumption",
    name: "Standard solar power generation (Self consumption)",
  },
  {
    id: "selfconsumption_standard_s",
    name: "Self consumption solar power generation",
  },
  {
    id: "selfconsumption_standard_battery_s",
    name: "Self consumption solar power generation + Battery",
  }
];
export const ASSET_DEFAULT_SCREENS = {
  'solar_standard_s': {
    'titleList' : [
      '', '1日のトレンドグラフ', '発電電力量の1日の変化', '発電電力量の1ヶ月の変化', '発電電力量の1年の変化',
      '太陽光発電の特徴', '太陽電池の仕組み', '電力の有効な活用'
    ],
    screenSetting : [
      {
        screenId: 'keisoku',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_trend',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_daily',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_monthly',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_annual',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'taiyokohatsudennotokucho',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'taiyodenchinoshikumi',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'denryokunoyukokatsuyo',
        assetId: 'solar_standard_s'
      }
    ]
  },
  'selfconsumption_standard_s': {
    'titleList' : [
      '', '1日のトレンドグラフ', '電力量の1日の変化', '電力量の1ヶ月の変化', '電力量の1年の変化',
      '太陽電池の仕組み', '自家消費型太陽光発電とは', '発電したエネルギーを無駄にしない自家消費型太陽光発電'
    ],
    screenSetting : [
      {
        screenId: 'keisoku',
        assetId: 'selfconsumption_standard_s'
      },
      {
        screenId: 'graph_trend',
        assetId: 'selfconsumption_standard_s'
      },
      {
        screenId: 'graph_daily',
        assetId: 'selfconsumption_standard_s'
      },
      {
        screenId: 'graph_monthly',
        assetId: 'selfconsumption_standard_s'
      },
      {
        screenId: 'graph_annual',
        assetId: 'selfconsumption_standard_s'
      },
      {
        screenId: 'taiyodenchinoshikumi',
        assetId: 'selfconsumption_standard_s'
      },
      {
        screenId: 'jikashouhitowa',
        assetId: 'selfconsumption_standard_s'
      },
      {
        screenId: 'chisanchisho',
        assetId: 'selfconsumption_standard_s'
      }
    ]
  },
  'solar_standard_surplus_electricity_sales': {
    'titleList' : [
      '', '1日のトレンドグラフ', '発電電力量の1日の変化', '発電電力量の1ヶ月の変化', '発電電力量の1年の変化',
      '太陽光発電の特徴', '太陽電池の仕組み', '電力の有効な活用'
    ],
    screenSetting : [
      {
        screenId: 'keisoku',
        assetId: 'solar_standard_surplus_electricity_sales'
      },
      {
        screenId: 'graph_trend',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_daily',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_monthly',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_annual',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'taiyokohatsudennotokucho',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'taiyodenchinoshikumi',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'denryokunoyukokatsuyo',
        assetId: 'solar_standard_s'
      }
    ]
  },
  'solar_standard_selfconsumption': {
    'titleList' : [
      '', '1日のトレンドグラフ', '発電電力量の1日の変化', '発電電力量の1ヶ月の変化', '発電電力量の1年の変化',
      '太陽光発電の特徴', '太陽電池の仕組み', '電力の有効な活用'
    ],
    screenSetting : [
      {
        screenId: 'keisoku',
        assetId: 'solar_standard_selfconsumption'
      },
      {
        screenId: 'graph_trend',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_daily',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_monthly',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'graph_annual',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'taiyokohatsudennotokucho',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'taiyodenchinoshikumi',
        assetId: 'solar_standard_s'
      },
      {
        screenId: 'denryokunoyukokatsuyo',
        assetId: 'solar_standard_s'
      }
    ]
  },
  'selfconsumption_standard_battery_s': {
    'titleList' : [
      '', '1日のトレンドグラフ', '電力量の1日の変化', '電力量の1ヶ月の変化', '電力量の1年の変化',
      '蓄電池のしくみ', '蓄電池でエネルギーを賢く使う', '災害時に役立つ蓄電池システム', '自家消費型太陽光発電とは',
      '地産地消でエネルギーを無駄なく使う'
    ],
    screenSetting : [
      {
        screenId: 'keisoku',
        assetId: 'selfconsumption_standard_battery_s'
      },
      {
        screenId: 'graph_trend',
        assetId: 'selfconsumption_standard_battery_s'
      },
      {
        screenId: 'graph_daily',
        assetId: 'selfconsumption_standard_battery_s'
      },
      {
        screenId: 'graph_monthly',
        assetId: 'selfconsumption_standard_battery_s'
      },
      {
        screenId: 'graph_annual',
        assetId: 'selfconsumption_standard_battery_s'
      },
      {
        screenId: 'chikudenchinoshikumi',
        assetId: 'selfconsumption_standard_battery_s'
      },
      {
        screenId: 'kashikokutsukau',
        assetId: 'selfconsumption_standard_battery_s'
      },
      {
        screenId: 'saigainiyakudatsu',
        assetId: 'selfconsumption_standard_battery_s'
      },
      {
        screenId: 'jikashouhitowa',
        assetId: 'selfconsumption_standard_s'
      },
      {
        screenId: 'chisanchisho',
        assetId: 'selfconsumption_standard_battery_s'
      },
    ]
  }
};
export const PPA_API_BASEURL = getPpaApiUrl();
export const PPA_PRODUCTLIST_NUM = 50;
export const PPA_PATTERNNAME_LENGTH = 20;
export const PPA_DEFAULTSETTING = {
  "supplierId": "",
  "patternName": "パターン",
  "isDefault": false,
  "invoiceCalculation": [
    {
      "calcTarget": "consumption",
      "basePrice": "",
      "reEneLevy": "",
      "fuelAdjustmentCost": "",
      "pricingRange": {
        "buy": [
          {
            "over": 0,
            "unitPrice": ""
          },
          {
            "over": "",
            "unitPrice": ""
          }
        ],
        "selfConsumption": [
          {
            "over": 0,
            "unitPrice": ""
          },
          {
            "over": "",
            "unitPrice": ""
          }
        ],
        "consumption": [
          {
            "over": 0,
            "unitPrice": ""
          },
          {
            "over": "",
            "unitPrice": ""
          }
        ]
      }
    }
  ],
  "coefficient": {
    "smartPhone": 111,
    "electricCar": 5.4
  },
  "screens": [
    {
      "asset": {
        "screenId": "skelton"
      },
      "measuredItems": "noSellConsumption"
    }
  ]
};

// 0: 正常, 1: ロード中, 2: 正常通信だがデータがない, -1: 通信できてない
export const API_STATUS = {
  OK: 0,
  LOADING: 1,
  NO_BODY: 2,
  NO_RESPONSE: -1
};

// 0: デフォルト, 1: PPA
export const HEADER_VIEW_PATTERN = {
  DEFAULT: 0,
  PPA: 1
};

function getSessionInitUrl() {
  return (getEnergymntrUrl() + 'login/index.php?autologin=true&');
}
function getEnergymntrUrl() {
  if (ISDEV) {
    return ('https://aed.energymntr.com/');
  } else {
    return ('https://services.energymntr.com/');
  }
}
function getSesApiUrl() {
  if (ISDEV) {
    return ('https://7k77hlscv9.execute-api.ap-northeast-1.amazonaws.com/devStage/postmaildev');
  } else {
    return ('https://5r3nhjb945.execute-api.ap-northeast-1.amazonaws.com/prod/postmail');
  }
}
function getCheckcodeApiUrl() {
  if (ISDEV) {
    return ('https://7k77hlscv9.execute-api.ap-northeast-1.amazonaws.com/devStage/checkcodedev');
  } else {
    return ('https://5r3nhjb945.execute-api.ap-northeast-1.amazonaws.com/prod/checkcode');
  }
}
function getGetlangApiUrl() {
  if (ISDEV) {
    return ('https://7k77hlscv9.execute-api.ap-northeast-1.amazonaws.com/devStage/getacceptlanguagedev');
  } else {
   return ('https://5r3nhjb945.execute-api.ap-northeast-1.amazonaws.com/prod/getacceptlanguage');
  }
}
function getCruseSettingApiUrl() {
  if (ISDEV) {
    return ('https://6vbfyjfc9a.execute-api.ap-northeast-1.amazonaws.com/techmock/config/');
  } else {
    return ('https://4zuny84hkd.execute-api.ap-northeast-1.amazonaws.com/service/config/');
  }
}
function getCruseSettingApiKey() {
  if (ISDEV) {
    return ('PL32REJRJ92qAG8XWNrpC3w2tVjkIDFn8vpyCk4c');
  } else {
    return ('bN3AMBUtoZ4jhiCpok6xD7lWgB94mZuY1Cqao0rT');
  }
}
function getPrContentsUrl() {
  if (ISDEV) {
    return ('https://d1rjx29b12zvc7.cloudfront.net/');
  } else {
   return ('https://mierukaweb.energymntr.com/');
  }
}
function getAuthzdbUrl() {
  return process.env.REACT_APP_AUTHZ_URL;
}
function getGrandArchUrl() {
  if (ISDEV) {
    return ('https://grandarch-dev.energymntr.com/');
  } else {
   return ('https://grandarch.energymntr.com/');
  }
}
export function getInvoiceApiUrl(param) {
  return process.env.REACT_APP_INVOICE_URL + param;
}
function getPpaApiUrl() {
  return process.env.REACT_APP_PPAAPI_BASEURL;
}
function getPpmsUrl() {
  if (ISDEV) {
    return ('https://ppms-dev.energymntr.com/');
  } else {
   return ('https://ppms.energymntr.com/');
  }
}
